import { forwardRef } from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/utils/cn';

interface CheckboxProps {
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  id?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ checked = false, onCheckedChange, disabled = false, className, id, ...props }, ref) => {
    return (
      <label className="relative inline-flex cursor-pointer checkbox-focus">
        <input
          ref={ref}
          type="checkbox"
          id={id}
          checked={checked}
          onChange={(e) => onCheckedChange?.(e.target.checked)}
          disabled={disabled}
          className="sr-only"
          {...props}
        />
        <div
          className={cn(
            'checkbox-visual flex items-center justify-center w-4 h-4 border-2 rounded transition-all duration-200',
            checked
              ? 'bg-blue-600 border-blue-600 text-white'
              : 'bg-white border-gray-300 hover:border-gray-400',
            disabled && 'opacity-50 cursor-not-allowed',
            className
          )}
        >
          {checked && (
            <Check className="w-3 h-3 text-white" strokeWidth={3} />
          )}
        </div>
      </label>
    );
  }
);

Checkbox.displayName = 'Checkbox';